"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = exports.chunk = exports.toNumber = exports.hasOwnProperty = exports.shortCircuit = exports.asyncFind = exports.asyncForEachMap = exports.asyncForEach = void 0;
async function asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
}
exports.asyncForEach = asyncForEach;
async function asyncForEachMap(map, callback) {
    for (let [key, value] of map) {
        await callback(value, key, map);
    }
}
exports.asyncForEachMap = asyncForEachMap;
async function asyncFind(array, callback) {
    let match;
    for (let index = 0; index < array.length; index++) {
        if ((await callback(array[index], index, array)) === true) {
            match = array[index];
            break;
        }
    }
    return match;
}
exports.asyncFind = asyncFind;
/**
 * Iterates an array, and returns the first element for which the predicate
 * returns a value.
 */
function shortCircuit(input, predicate) {
    let output;
    input.some((value, index, array) => !!(output = predicate(value, index, array)));
    return output;
}
exports.shortCircuit = shortCircuit;
// https://fettblog.eu/typescript-hasownproperty/
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
exports.hasOwnProperty = hasOwnProperty;
function toNumber(value) {
    const number = Number(value);
    if (!Number.isFinite(number)) {
        throw new Error('Not a number');
    }
    return number;
}
exports.toNumber = toNumber;
function chunk(array, size) {
    return array.reduce((chunked, item, index) => {
        const chunkIndex = Math.floor(index / size);
        if (!chunked[chunkIndex]) {
            chunked[chunkIndex] = []; // start a new chunk
        }
        chunked[chunkIndex].push(item);
        return chunked;
    }, []);
}
exports.chunk = chunk;
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
exports.capitalize = capitalize;
//# sourceMappingURL=utils.js.map